import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';
import { CookieService } from 'ngx-cookie-service';

@Injectable({
  providedIn: 'root'
})
export class TransactionService {

  constructor(     private _httpClient: HttpClient,
    private cookieService: CookieService) { 

  }
  get token(): string | null {
   // return localStorage.getItem('accessToken');
   return this.cookieService.get('accessToken');
  }

  public getList(page ,limit , search , body?,observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set('page', page as any);
    queryParameters = queryParameters.set('limit', limit as any);
    queryParameters = queryParameters.set('search', search as any);

    let headers = new HttpHeaders();
    headers = headers.set('idSession',this.token);
    return this._httpClient.request<any>(
      'post',
      environment.apiUrl+`/informations-transaction/list`,
      {
        params: queryParameters,
        headers: headers,
        observe: observe,
        body: body,
        reportProgress: reportProgress
      }
    );
  }



  public UploadFile(uploadFile: any, observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    if (uploadFile === null || uploadFile === undefined) {
      throw new Error('Required parameter idContrat was null or undefined when calling listDocumentContratMobileGet.');
    }


    let headers = new HttpHeaders();
    headers = headers.set('idSession',this.token);


    return this._httpClient.request<any>('post',environment.apiUrl+ `/upload`, {
      headers: headers,
      observe: observe,
      reportProgress: reportProgress,
      body: uploadFile,
    });
  }



  public getFile(name, entity ,observe: any = 'body', reportProgress: boolean = false): Observable<any> {
    let queryParameters = new HttpParams();
    queryParameters = queryParameters.set('filename', name as any);
    queryParameters = queryParameters.set('entity', entity as any);

      let headers = new HttpHeaders();
      headers = headers.set('idSession', this.token);
      return this._httpClient.request<any>(
        'get',
        environment.apiUrl+`/get_file`,
        {
          params:queryParameters,
          headers: headers,
          observe: observe,
          reportProgress: reportProgress
        }
      );
    }
  
}
